import { Appointment } from "@elixir/types";
import { GET_PARCHI_HOST } from "../constants/env";
import fetch from "../fetch-client";
import { ParchiGenericApiResponse } from "../types/parchi";

export default async function postPushOrderToEvitals({
  aid,
}: {
  aid: Appointment["aid"];
}): Promise<ParchiGenericApiResponse<{}>> {
  try {
    const PARCHI_HOST = GET_PARCHI_HOST();
    let endpoint = `${PARCHI_HOST}/app/pharma-order/${aid}`;

    const res = await fetch(endpoint, {
      method: "POST",
      redirect: "follow",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
    });

    return res.json();
  } catch (e) {
    return { success: false };
  }
}
